import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl';
import { connect } from '@atlassian/jira-react-redux';
import { getProjectKey, getBaseUrl } from '../../../state/selectors/base';
import type { State } from '../../../state/types';
import KnowledgeBaseSearchBreadcrumb from './view';

const mapStateToProps = (state: State) => ({
	projectKey: getProjectKey(state),
	baseUrl: getBaseUrl(state),
});

export default injectIntl(connect(mapStateToProps, {})(KnowledgeBaseSearchBreadcrumb));
